// extracted by mini-css-extract-plugin
export var createdDate = "_nc-1";
export var divider = "_nc-2";
export var headerDivider = "_nc-3";
export var messagesCard = "_nc-0";
export var messagesContainer = "_nc-7";
export var messagesContainerWrapper = "_nc-4";
export var pointerCapturingButtonBoxes = "_nc-a";
export var showLeftPanelButton = "_nc-9";
export var showMoreButton = "_nc-c";
export var showMoreButtonContainer = "_nc-b";
export var summaryTitle = "_nc-6";
export var systemMessageCardWrapper = "_nc-d";
export var topButtons = "_nc-8";
export var withPadding = "_nc-5";